/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import { Button } from '@mui/material';
import { Hidden } from "@material-ui/core";
import RefreshIcon from '@mui/icons-material/Refresh';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingComponent from '../../lib/LoadingComponent';
import { useDispatch, useSelector } from 'react-redux'
import Alert from '@mui/material/Alert';
import FadeIn from 'react-fade-in'
import {
  getBizName, getLogo, setLogo, getStyle, setBizID, setStyle, setBusinessName, setAuthen, setRoles, setConfirmEmail, setServices
} from '../../libs/todoSlice'
import fontColor from '../../lib/fontColor';
import Cookie from '../../lib/Cookie';
import {
  getConfirmMailFeedbackRedux, setConfirmMailFeedbackRedux, getResendLoadingRedux
  , setResendLoadingRedux, getRecheckLoadingRedux, setRecheckLoadingRedux
} from '../../libs/sendMailSuccessSlice';
import { logoutSession } from '../../lib/logoutRedirect';

function SendMailSuccess({ result = Function }) {
  // const [ email, setEmail ] = useState('')
  // const [ comfirmMailFeedback, setConfirmMailFeedback ] = useState('')
  // const [ resendLoading, setResendLoading ] = useState(false)
  // const [ recheckLoading, setRecheckLoading ] = useState(false)
  const [cookie, setCookie, removeCookie] = useCookies(['new_user', 'account', 'cookie_consent_accepting'])
  const params = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const businessName = useSelector(getBizName)
  const logo = useSelector(getLogo)
  const style = useSelector(getStyle)


  const comfirmMailFeedback = useSelector(getConfirmMailFeedbackRedux)
  const setConfirmMailFeedback = (action) => {
    dispatch(setConfirmMailFeedbackRedux({
      comfirmMailFeedback: action
    }))
  }

  const resendLoading = useSelector(getResendLoadingRedux)
  const setResendLoading = (action) => {
    dispatch(setResendLoadingRedux({
      resendLoading: action
    }))
  }

  const recheckLoading = useSelector(getRecheckLoadingRedux)
  const setRecheckLoading = (action) => {
    dispatch(setRecheckLoadingRedux({
      recheckLoading: action
    }))
  }


  useEffect(() => {
    // setEmail(searchParams.get('email'))
    getPrefixDetail()
  }, [])
  const getPrefixDetail = async () => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/prefix?prefix=${params.prefix}`,
    }).then(({ data, status }) => {
      if (!data.data) {
        navigate('/notfound')
      } else {
        dispatch(setBizID({
          biz_id: data.data.businessID
        }))
        dispatch(setStyle({
          style: data.data.themes.style
        }))
        dispatch(setServices({
          services: data.data.services
        }))
      }
      getLogoApi(data.data.businessID)
      dispatch(setBusinessName({
        business_name: data.data.businessName
      }))
    }, ({ response }) => {
    })
  }
  const getLogoApi = async (bizid) => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/logo?business_id=${bizid}`,
    }).then(({ data, status }) => {
      dispatch(setLogo({
        logo: data.data
      }))
    }, ({ response }) => {

    })
  }
  const resendEmail = async () => {
    setResendLoading(true)
    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/loalevel`,
    }).then(() => {
      // navigate(`/${params.prefix}/login-user/send-mail/success?email=${email}`)
    }, ({ response }) => {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    })
    setResendLoading(false)
  }

  const recheck = async () => {
    setRecheckLoading(true)
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/loalevel`,
    }).then(({ data }) => {
      if (!data.data.confirmed) {
        setConfirmMailFeedback({
          message: 'กรุณายืนยันตัวตนของคุณผ่านทางอีเมลให้เรียบร้อย เพื่อดำเนินการต่อ',
          color: 'warning'
        })
      } else {
        // if(cookie.cookie_consent_accepting){
        setCookie('new_user', {
          ...cookie.new_user,
          confirmed_email: data.data.confirmed,
        }, {
          path: '/',
          expires: new Date(Date.now() + 3600000),
          // httpOnly: true
        })
        if (data.data.confirmed) {
          setCookie('new_user', {
            changed_password: cookie.new_user.changed_password,
            confirmed_email: true,
          }, { path: '/', expires: new Date(Date.now() + 3600000) })
          dispatch(setConfirmEmail({
            confirmed_email: data.data.confirmed
          }))
          navigate(`/${params.prefix}/login-user/verify-success`)
        }
        result(data.data.confirmed)
        setRecheckLoading(false)
        // }
      }
    }, ({ response }) => {
      const { status } = response
      setRecheckLoading(false)
      result(true)
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    })
    setRecheckLoading(false)
  }
  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: params.prefix,
    })
  };
  return (
    <div
      style={{
        background: '#F8F9FA',
        height: '100vh',
      }}
    >
      <div style={{ padding: '30px 80px 0 80px' }}>
        <img src={`data:image/png;base64, ${logo}`} alt=""
          onError={({ target }) => {
            target.src = '/one-platform.png'
          }}
          style={{
            maxHeight: '60px',
            maxWidth: '60px',
          }} />
        <span
          style={{
            fontWeight: '600',
            color: '#000',
            padding: '10px',
          }}
        >{businessName}</span>
        <span
          style={{
            float: 'right',
          }}
        >
          <Button
            onClick={() => {
              logout()
            }}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              padding: '9px 15px',
              gap: '10px',
              width: '120px',
              height: '36px',
              borderRadius: '6px',
              float: 'right',
              color: fontColor(style.secondary_color),
              background: style.secondary_color,
            }}
          >
            ออกจากระบบ
          </Button>
        </span>
      </div>
      <Hidden xsDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <img
            src="/img_create_path.png"
            style={{
              position: 'fixed',
              width: '670.75px',
              height: '650.54px',
              top: '110px',
            }}
            alt=''
          />
        </div>
      </Hidden>
      {comfirmMailFeedback.message &&
        <FadeIn>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <Alert severity={comfirmMailFeedback.color}>
              {comfirmMailFeedback.message}
            </Alert>
          </div>
        </FadeIn>
      }
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '60px 40px',
          gap: '36px',
        }}
      >
        <div style={{ zIndex: '1' }}>
          <Card
            style={{
              width: '467px',
              background: 'rgba(0, 0, 0, 0.2)',
              borderRadius: '32px',
              padding: '60px 40px',
              color: '#053075'
            }}
          >
            <div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/icon_mail_login-user.png"
                  style={{
                    width: '48px',
                    height: '48px'
                  }}
                  alt=''
                />
              </div>
              <div>
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontWeight: '700',
                    fontSize: '18px',
                    lineHeight: '50px',
                    letterSpacing: '0.02em',
                  }}>ทำการส่งอีเมลเรียบร้อยแล้ว</span>
              </div>
              <div style={{ paddingTop: '10px', textAlign: 'center', letterSpacing: '0.02em' }}>
                <span>กรุณาทำการยืนยันตัวตนผ่านอีเมล</span><br />
                <span>หากไม่ได้รับอีเมลสามารถทำการส่งใหม่ได้อีกครั้ง</span>
              </div>
              <div style={{ marginTop: '20px' }}>
                {recheckLoading ? <LoadingComponent /> :
                  <Button
                    style={{
                      width: '387px',
                      height: '36px',
                      borderRadius: '6px',
                      textTransform: 'none',
                      color: fontColor(style.secondary_color),
                      background: style.secondary_color,
                    }}
                    onClick={() => {
                      recheck()
                    }}
                  >
                    ดำเนินการต่อ
                  </Button>
                }
              </div>
              <div style={{ marginTop: '20px' }}>
                {resendLoading ? <LoadingComponent /> :
                  <Button
                    style={{
                      width: '387px',
                      height: '36px',
                      borderRadius: '6px',
                      color: 'white',
                      border: '1px solid white'
                    }}
                    onClick={() => {
                      resendEmail()
                    }}
                  >
                    <RefreshIcon style={{ fontSize: 'medium', marginRight: '5px' }} />
                    <span>ส่งอีกครั้ง</span>
                  </Button>
                }
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default SendMailSuccess